import { useMultiStepForm } from '../../Hooks/Features/WelcomeKit/useMultiStepForm';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';


const MultiStepForm = () => {
    const { StepComponent, nextStep, prevStep, handleChange, formData, currentStep, steps, data } = useMultiStepForm()
    return (
        <div className='d-flex w100' style={{ height: "inherit" }}>
            <div className='w5 d-flex justify-content-center' style={{ height: "90vh", overflow: "auto" }}>
                <Stepper orientation="vertical" activeStep={currentStep}>
                    {Array.from({ length: 21 }, (_, index) => (
                        <Step key={index}>
                            <StepLabel> </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </div>
            <div className='w95 px-2 welcome-kit' style={{ height: "calc(100vh-210px)", overflow: "auto", overflowX: "hidden" }}>
                <StepComponent
                    formData={formData}
                    onChange={handleChange}
                    onNext={nextStep}
                    onPrev={prevStep}
                    isLastStep={currentStep === steps.length - 1}
                    data={data}
                    label={steps[currentStep]?.label}
                    readOnly={false}
                />
            </div>
        </div>
    );
};

export default MultiStepForm;